import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';

const Kenmerken = (props) => (
 <div dangerouslySetInnerHTML={{__html: props.pageKenmerkenContent}}/>
)

export default HeaderFooterHOC(Kenmerken, 'manual-kenmerken');
